import { openDB } from 'idb';

const DB_NAME = 'MyShoppingWeb';
const DB_VERSION = 1;
const TOKEN_STORE_NAME = 'MyShoppingWebDB';

export const DeleteTokenInIndexDB = async (key: string) => {
  try {
    const dbExists = await CheckIfDBExists(DB_NAME);
    if (dbExists) {
      await DeleteToken(key);
    } else {
      console.log('Database does not exist.');
    }
  } catch (err: any) {
    alert(`Error deleting token from IndexedDB: ${err}`);
  }
};

async function CheckIfDBExists(dbName: string): Promise<boolean> {
  const dbNames = await window.indexedDB.databases();
  return dbNames.some((db) => db.name === dbName);
}

async function DeleteToken(key: string) {
  try {
    const db = await openDB(DB_NAME, DB_VERSION);
    const tx = db.transaction(TOKEN_STORE_NAME, 'readwrite');
    const store = tx.objectStore(TOKEN_STORE_NAME);
    await store.delete(key);
    db.close();
  } catch (error: any) {
    console.error('Error deleting token from database:', error);
  }
}
